"use client"

export default function PaymentMethodSelector({ paymentMethod, onChange, countryOfInterest }) {
  return (
    <div className="space-y-2">
      <label className="block text-sm mb-1">Payment Method</label>
      <div className="flex gap-4">
        <label className="flex items-center">
          <input
            type="radio"
            name="paymentMethod"
            value="bank"
            checked={paymentMethod === "bank"}
            onChange={(e) => onChange(e.target.value)}
            className="mr-2"
          />
          Bank Transfer
        </label>
        <label className="flex items-center text-gray-400">
          <input
          disabled
            type="radio"
            name="paymentMethod"
            value="creditCard"
            // checked={paymentMethod === "creditCard"}
            // onChange={(e) => onChange(e.target.value)}
            className="mr-2"
          />
          Credit Card
        </label>
        {countryOfInterest === "Australia" && <label className="flex items-center">
          <input
            type="radio"
            name="paymentMethod"
            value="payId"
            checked={paymentMethod === "payId"}
            onChange={(e) => onChange(e.target.value)}
            className="mr-2"
          />
          Pay Id
        </label>}
      </div>
    </div>
  )
}

